import { MenuItem } from '../../features/home/models/menu-item.model';
import { resolveMenuIcon } from './menu-icon.registry';
import {
  MenuNodeDto,
  PermissionRole,
  PermissionsResponseDto,
  RoleDto,
  UserPermissions,
} from './navigation.model';

/** Mapea el árbol de nodos del backend al `MenuItem` del sidebar, ordenado por `sortOrder`. */
export function dtoToMenuItems(nodes: MenuNodeDto[]): MenuItem[] {
  return [...nodes].sort((a, b) => a.sortOrder - b.sortOrder).map(dtoToMenuItem);
}

function dtoToMenuItem(node: MenuNodeDto): MenuItem {
  const children = node.children?.length ? dtoToMenuItems(node.children) : undefined;
  return {
    label: node.name,
    icon: resolveMenuIcon(node.icon),
    // SUBMENU usa `routerPath`; MENU enlace directo usa `basePath`; agrupador → sin ruta.
    route: node.routerPath ?? node.basePath,
    children,
  };
}

/** Mapea la respuesta de permisos al dominio (claves planas + roles normalizados). */
export function dtoToPermissions(dto: PermissionsResponseDto): UserPermissions {
  return {
    roles: dto.roles.map(dtoToRole),
    keys: dto.permissions.map((p) => p.permissionKey),
  };
}

function dtoToRole(dto: RoleDto): PermissionRole {
  return {
    id: dto.id,
    code: dto.code,
    name: dto.name,
    criticality: dto.criticallity,
    isBreakGlass: dto.isBreakGlass,
  };
}
